import { fromJS } from 'immutable';
import { MODULE_NAME } from '../constants/modules';

export const ACTION_PREFIX = `modules/${MODULE_NAME}`;
export const CARD_OFFERS_LOADING = `${ACTION_PREFIX}/CARD_OFFERS_LOADING`;
export const CARD_OFFERS_LOADED = `${ACTION_PREFIX}/CARD_OFFERS_LOADED`;
export const CARD_OFFERS_ERROR = `${ACTION_PREFIX}/CARD_OFFERS_ERROR`;
export const TRAVEL_CREDIT_TAB_OPEN = `${ACTION_PREFIX}/TRAVEL_CREDIT_TAB_OPEN`;
export const TRAVEL_CREDIT_TAB_CLOSED = `${ACTION_PREFIX}/TRAVEL_CREDIT_TAB_CLOSED`;
export const RESET_CARD_OFFERS_PATH = `${ACTION_PREFIX}/RESET_CARD_OFFERS_PATH`;

export const setCardOffersLoading = () => ({
  type: CARD_OFFERS_LOADING,
});

export const setCardOffersLoaded = (cardOffersPath) => ({
  type: CARD_OFFERS_LOADED,
  cardOffersPath,
});

export const setCardOffersError = () => ({
  type: CARD_OFFERS_ERROR,
});

export const resetCardOffersPath = {
  type: RESET_CARD_OFFERS_PATH,
};

export const setTravelCreditTabOpen = {
  type: TRAVEL_CREDIT_TAB_OPEN,
};

export const setTravelCreditTabClosed = {
  type: TRAVEL_CREDIT_TAB_CLOSED,
};

export const initialState = fromJS({
  isCardOffersLoading: false,
  cardOffersPath: undefined,
  hasCardOffersErrors: false,
  showTravelCreditTab: false,
});

const homeReducer = (state = initialState, action = {}) => {
  switch (action && action.type) {
    case CARD_OFFERS_LOADING: {
      return state.set('isCardOffersLoading', true);
    }
    case CARD_OFFERS_LOADED: {
      return state.merge({
        isCardOffersLoading: false,
        hasCardOffersErrors: false,
        cardOffersPath: action.cardOffersPath,
      });
    }
    case RESET_CARD_OFFERS_PATH: {
      return state.set('cardOffersPath', null);
    }
    case CARD_OFFERS_ERROR: {
      return state.merge({
        isCardOffersLoading: false,
        hasCardOffersErrors: true,
      });
    }
    case TRAVEL_CREDIT_TAB_OPEN: {
      return state.set('showTravelCreditTab', true);
    }
    case TRAVEL_CREDIT_TAB_CLOSED: {
      return state.set('showTravelCreditTab', false);
    }
    default:
      return state;
  }
};

export default homeReducer;
